"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_use_promise_1 = __importDefault(require("react-use-promise"));
exports.default = (function (promiseOrFunction, deps, defaultValue) {
    var _a = react_1.useState(defaultValue), result = _a[0], setResult = _a[1];
    var _b = react_use_promise_1.default(promiseOrFunction, deps), resp = _b[0], error = _b[1], status = _b[2];
    react_1.useEffect(function () {
        if (resp)
            setResult(resp);
    }, [resp]);
    return [result, error, status];
});
